/**
 * Created by SH: 20/02/2020
 */

import {PREngineView} from "./PREngineView";
import {gsap} from 'gsap';
import {PunkSymbol} from "./symbol/PunkSymbol";
import {GameConfig} from "../config/base/GameConfig";

import {ReelStartCallbacks, ReelStopCallbacks} from "../../core/reel/IData/IReelData";
import {Helper} from "../../core/utils/Helper";
import {PunkSymbolData} from './symbol/PunkSymbolData';
import {ReelState} from "../../core/reel/ReelEngineView";
import {ReelSymbolStates} from "../../core/reel/symbol/ReelSpriteSymbolArea";
import {Sequence} from "../../core/displayobject/Sequence";
import {SymbolData} from "../../core/reel/symbol/config/SymbolData";
import {BLEND_MODES} from 'pixi.js';
import {MathHelper} from "../../core/utils/MathHelper";
import {PunkRocker} from "../PunkRocker";
import {BaseServerData} from "../server/base/IData";
import {PRGameMode} from "../server/PRGameMode";

export class PREngineController extends PREngineView {
    private attentionSeq: Sequence;
    private reelGlow: Sequence;
    private reelLightning: Sequence;
    private reelOverlayGFX: PIXI.Graphics;
    private reelLocker: Sequence;

    public get AllSticky(): PunkSymbol[] {
        return this._stickyContainer.children as PunkSymbol[];
    }

    public getSymbol(symbolID: number): PunkSymbol | undefined {
        // Fetching the Sticky first.
        const sticky: PunkSymbol | undefined = this.AllSticky.find((sym: PunkSymbol) => {
            return sym.posID.includes(symbolID)
        });
        if (sticky) {
            return sticky;
        }

        const sym: PunkSymbol | undefined = this.AllSymbols.find((sym: PunkSymbol) => {
            return sym.posID.includes(symbolID)
        });

        if (sym) {
            return sym;
        }

        return undefined;
    }

    public lock(v: boolean): void {
        if (!this.reelLocker) {
            this.reelLocker = PunkRocker.overlayAnim.addChild(new Sequence({texturePath: "ReelLocker"}));
            this.reelLocker.name = "lockingChain";
            this.reelLocker.position = Helper.copyLocalPosition(this.reelLocker, this);
            this.reelLocker.position.y += SymbolData.DEFAULT_DIM.HEIGHT;
            this.reelLocker.anchor.set(0.5, 0.5);
            this.reelLocker.visible = true;
        }

        this.isActive = !v;
        this.reelLocker.play({
            onStart: () => {
                this.reelLocker.visible = true;
            },
            reverse: !v,
            onCompleteCallback: () => {
                this.reelLocker.visible = v;
            }
        });
    }

    public createStart(cb?: ReelStartCallbacks, reverse: boolean = false): void {
        this.startCallbacks = cb ? cb : {};
        this.engine.reverse = reverse;

        if (this.isActive) {
            this.createNextAnimation(() => this.engine.Start(this.startDuration, this.startEase), ReelState.START);
        } else {
            if (this.reelLocker && this.reelLocker.visible) {
                this.createNextAnimation(() => this.engine.StartTeaser(this.startDuration * 2, this.config.EASING.START_TEASER), ReelState.INACTIVE);
            } else
                this.createNextAnimation(() => this.engine.Idle(), ReelState.INACTIVE);
        }
    }

    parseData(data: any): void {
        super.parseData(data);
    }

    onStarting(): void {
        super.onStarting();
    }

    onStopAnimationCompleted(): void {
        super.onStopAnimationCompleted();
    }

    addChildObjOrder(): void {
        super.addChildObjOrder();
    }

    public createStop(cb?: ReelStopCallbacks, mergeSlam: boolean = false, attentionStop: boolean = false): gsap.core.Timeline {
        this.stopCallbacks = cb ? cb : {};

        this.attentionStop = attentionStop;

        if (!this.isQuickStop) {
            if (attentionStop)
                return this.createNextAnimation(() => this.engine.Stop(GameConfig.REEL_ENGINE_CONFIG.DURATION.ATTENTION_STOP, GameConfig.REEL_ENGINE_CONFIG.EASING.ATTENTION_STOP));
        }
        return this.createNextAnimation(() => this.engine.Stop(this.stopDuration, this.stopEase));
    }

    public initReel(): void {

        // this.reelOverlayGFX = this.createGraphic(0xece75f,1);
        this.reelOverlayGFX = this.createGraphic(0x000000, 1);
        this.reelOverlayGFX.zIndex = 10;
        this.reelOverlayGFX.alpha = 0;

        super.initReel();
        // (PunkRocker.overlayAnim.playSequence(this,PunkRocker.assetLoader.getTextures("WildFire")).item as Sequence).blendMode = BLEND_MODES.ADD;

        this.reelGlow = this.addChild(new Sequence({texturePath: "Reel_Attention"}));
        this.reelGlow.position.y += 180;
        this.reelGlow.anchor.set(0.5, 0.5);
        this.reelGlow.blendMode = BLEND_MODES.ADD;
        this.reelGlow.alpha = 0;

        this.attentionSeq = this.addChild(new Sequence({texturePath: "ReelAttentionFire"}));
        this.attentionSeq.position.y += 180;
        this.attentionSeq.anchor.set(0.5, 0.5);
        this.attentionSeq.blendMode = BLEND_MODES.ADD;
        this.attentionSeq.alpha = 0;

        this.reelLightning = this.addChild(new Sequence({texturePath: "Reel_Electric"}));
        this.reelLightning.position.y += 180;
        this.reelLightning.anchor.set(0.5, 0.5);
        this.reelLightning.blendMode = BLEND_MODES.ADD;
        this.reelLightning.alpha = 0;

        const allWindowSymbols: PunkSymbol[] = this.AllWindowSymbols;
        allWindowSymbols.forEach((s: PunkSymbol, idx: number) => {
            // #264
            if (allWindowSymbols[idx + 1] && allWindowSymbols[idx + 1].isLowValue) {
                s.enableDivider(true);
            }
        });
        // this.getLocalBounds();
        // this.updateTransform();
        // debugger;

        this.sortChildren();
    }

    public overlayGraphicAlpha(toAlpha: number, durr: number): void {
        gsap.to(this.reelOverlayGFX, {alpha: toAlpha, duration: durr});
    }

    public playLightning(): void {
        this.reelLightning.alpha = 1;
        this.reelLightning.play({onCompleteCallback: () => this.reelLightning.alpha = 0});
    }

    // protected createGraphic(color: number = 0x000000, alpha: number = 0.2): PIXI.Graphics {
    //     const graphicBg: PIXI.Graphics = new PIXI.Graphics();
    //     graphicBg.beginFill(color, alpha);
    //     graphicBg.lineStyle(5, color, 1, undefined,)
    //     graphicBg.drawRoundedRect(-PunkSymbolData.DEFAULT_DIM.WIDTH * 0.5, -PunkSymbolData.DEFAULT_DIM.HEIGHT * 0.5,
    //         PunkSymbolData.DEFAULT_DIM.WIDTH, this.maxHeight, 4);
    //     graphicBg.endFill();
    //     this.addChild(graphicBg);
    //     return graphicBg;
    // }

    public showReelGlow(active: boolean, forTrain: string = "bottomTrain"): void {
        if (active) {
            if (forTrain === "topTrain") {
                this.reelGlow.scale.y = -1;
            } else {
                this.reelGlow.scale.y = 1;
            }

            gsap.to(this.reelGlow, {alpha: 1, duration: 0.2}).eventCallback("onComplete", () => {
                let tl = this.reelGlow.play({repeat: -1});
                tl.fromTo(this.reelGlow, {alpha: 1}, {alpha: 0.7, duration: 0.3});
                tl.fromTo(this.reelGlow, {alpha: .7}, {alpha: 1, duration: 0.3});
            })
        } else {
            this.reelGlow.stop();
            gsap.to(this.reelGlow, {alpha: 0, duration: 0.2});
        }

        // gsap.to(this.reelOverlayGFX, { alpha: toAlpha, duration:durr });
    }

    public playAttention(active: boolean): void {
        this.attentionSeq.play({
            repeat: active ? -1 : 0,
            onStart: () => {
                this.attentionSeq.visible = true
            },
            onCompleteCallback: () => this.attentionSeq.visible = false
        })
        gsap.to(this.attentionSeq, {alpha: active ? 1 : 0, duration: this.attentionSeq.totalDuration})
    }

    public adjustExpandingSymbols(reelId: number, symId: number, durr: number, allSymSizes: number[][]): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline(),
            symSizeTo: number = allSymSizes[reelId][symId],
            expandingSym: PunkSymbol | undefined = this.getSymbol(symId),
            totalSymCountInReel: number = symSizeTo + 3, //2 other + 1 buffer symbols in reel
            desiredSymSize: number = PunkSymbolData.fetchSizeTimesSize(totalSymCountInReel);

        if (expandingSym) {
            const sizeToShowMax_4: number = Math.min(4, symSizeTo);
            expandingSym.showSymMultiplier(durr, sizeToShowMax_4);
            this.createNextAnimation(() => this.engine.ExpandSymbol({
                duration: durr!,
                targetSym: symId,
                toSize: desiredSymSize,
                ease: GameConfig.REEL_ENGINE_CONFIG.EASING.EXPAND,
            }, this.AllWindowSymbols.length, this.AllWindowSymbols.length, this._symbolContainer), ReelState.EXPAND_SYM);

            this.engine.activateNextAnimation();
            tl.add(this.engine.activeTimeline!, 0);
        }

        this.AllWindowSymbols.forEach(currSym => {
            const currSymId: number = currSym.posID[0],
                maxSizeAllowed: number = Math.min(7, totalSymCountInReel),
                toSize: number = (currSymId === symId) ? maxSizeAllowed : (8 - maxSizeAllowed);

            currSym.changeState({
                state: ReelSymbolStates.NORMAL,
                sizeType: toSize,
                duration: durr,
                forceState: true,
                ease: GameConfig.REEL_ENGINE_CONFIG.EASING.EXPAND
            });
        });

        return tl;
    }

    public symPos(symID: number): PIXI.Point {
        return MathHelper.pointAdd(this.getSymbol(symID)!.position, this.position);
    }

    protected defineQuickReel(data: any): string[] {
        const t: string[] = Array.from(data.reels[this.reelID]) as string[],
            rawGameData: BaseServerData = PunkRocker.model.gameData.raw,
            currMode: PRGameMode = rawGameData.mode;

        if(!(currMode === PRGameMode.FREESPIN_LEVEL_ONE || currMode === PRGameMode.FREESPIN_LEVEL_TWO || currMode === PRGameMode.FREESPIN_LEVEL_THREE)) {
            if (data.data.evaluatedArea) {
                t.forEach((v, i) => {
                    if (i) {
                        if (data.data.evaluatedArea[this.reelID][i] == "W") {
                            t[i] = "W";
                        }
                    }
                })
            }
        }

        return t;
    }

    protected tryUpdateStep(): void {
        if (this.updateStep) {

            this.engine.stepDistance = PunkSymbolData.fetchSizeStep(this.config.WINDOW_AMOUNT);
            this.createNextAnimation(() => this.engine.Step(this.spinDuration));
            this.engine.activateNextAnimation();

            this.updateStep = false;
        }
    }

    protected setCurrentReelSet(name: string): void {
        super.setCurrentReelSet(name);
    }

    protected addSymbol(symbol: PunkSymbol): void {
        super.addSymbol(symbol);

        if (this.AllSymbols.length > 1 && this.AllSymbols[symbol.posID[0] + 1]) {
            symbol.createDivider(symbol.posID[0] != this.windowConfAmount - 1 && this.AllSymbols[1].isLowValue);
        }
    }
}
